import { render } from "./Jihan.vue?vue&type=template&id=24000a15"
import script from "./Jihan.vue?vue&type=script&lang=js"
export * from "./Jihan.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\bigSis_vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__